import React from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { marketplaceMeta, tokens } from '../../theme';

// A section whose data for this marketplace is not loaded yet (Ozon, Yandex Market).
const ComingSoon = ({ marketplace, what }) => {
  const meta = marketplaceMeta(marketplace);
  return (
    <Card>
      <CardContent sx={{ p: { xs: 3, md: 5 } }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} alignItems={{ sm: 'center' }}>
          <Box sx={{ width: 64, height: 64, borderRadius: '16px', bgcolor: meta.soft, color: meta.main, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <ScheduleRoundedIcon sx={{ fontSize: 32 }} />
          </Box>
          <Box>
            <Typography variant="h2" sx={{ mb: 0.75 }}>{what} {meta.label} — в ближайшем обновлении</Typography>
            <Typography color="text.secondary" sx={{ maxWidth: 680 }}>
              Кабинет уже подключён и доступ проверен. Как только загрузка данных {meta.label} будет запущена, раздел заполнится
              автоматически — ничего делать не нужно. Мы не показываем цифры, которых нет в данных площадки.
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ mt: 3, height: 6, borderRadius: '12px', bgcolor: tokens.primarySoft, overflow: 'hidden' }}>
          <Box sx={{ width: '35%', height: '100%', borderRadius: '12px', background: meta.gradient }} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ComingSoon;
